import { IFilter } from "../interfaces/IFilter";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const create = async (data: { text: string; isPublic: boolean }) => {
  return httpRequest.post("/erp/back_office/item_reference/inactive_type", data);
};

export const select = async (data: { query: string; limit?: number }) => {
  return httpRequest.get("/erp/back_office/item_reference/inactive_type/select", data);
};

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/erp/back_office/item_reference/inactive_type", { offset, filter });
};

export const update = async (id: string, data: { text: string; isPublic: boolean }) => {
  return httpRequest.put(`/erp/back_office/item_reference/inactive_type/${id}`, data);
};

export const remove = async (id: string) => {
  return httpRequest.del(`/erp/back_office/item_reference/inactive_type/${id}`);
};
